/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Template" |
*
* @param {Event_Templates_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_delete_title = /** @type {((inputs?: Event_Templates_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le modele")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina modello")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить шаблон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar plantilla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्पलेट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir modelo")
	return /** @type {LocalizedString} */ ("Delete Template")
});